module.exports = __webpack_public_path__ + "bg-category_deal2.jpg";